import { render, staticRenderFns } from "./DeleteOrders.vue?vue&type=template&id=40a1d25c&scoped=true&"
import script from "./DeleteOrders.vue?vue&type=script&lang=js&"
export * from "./DeleteOrders.vue?vue&type=script&lang=js&"
import style0 from "./DeleteOrders.vue?vue&type=style&index=0&id=40a1d25c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a1d25c",
  null
  
)

export default component.exports